import React, { useEffect } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import { ISearchField, ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { ioFlagDs, tradeTypeDs, billCancelStatusDs, billStatusDs } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";
import { useBillInternalModel } from "../billInternalModel";
import { useDetailModel } from "@/views/account/internal/detailModel";

export function PageHeader() {
    const {
        searchParam,
        resetSearchParam,
        updateSearchParam,
        loadData,
        customerUserDs
    } = useBillInternalModel();

    const { unit, user: { shopCode } } = useGlobalModel()


    const searchFields: ISearchField[] = [
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "交易方向",
            fieldName: "direction",
            size: "small",
            options: [{
                label: '调入',
                value: 'IN'
            }, {
                label: '调出',
                value: 'OUT'
            }],
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "账户名称",
            fieldName: "accountCode",
            options: customerUserDs?.filter(item => item.unitCode === unit?.code),
            size: "small",
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "单据编码",
            fieldName: "code",
            size: "small",
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "收款状态",
            fieldName: "payStatus",
            size: "small",
            options: billStatusDs,
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     placeholder: "授信类型",
        //     fieldName: "creditFlag",
        //     size: "small",
        //     options: creditFlagDs(),
        // },
        // {
        //     type: SearchTypeEnum.AsyncSelect,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "客户",
        //     fieldName: "partnerCode",
        //     size: "small",
        //     selectfetchList: fetchCustomerList,
        // },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "客户",
        //     fieldName: "partnerCode",
        //     size: "small",
        //     options: customerDs,
        // },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "单据类型",
        //     fieldName: "tradeTypeCode",
        //     size: "small",
        //     options: tradeTypeDs,
        // },
        // {
        //     type: SearchTypeEnum.Input,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "单据编号",
        //     fieldName: "tradeCode",
        //     size: "small",
        // },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     placeholder: "支付方式",
        //     fieldName: "payType",
        //     size: "small",
        //     options: payTypeOption,
        // },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 8,
            span: 8,
            placeholder: "起止",
            fieldName: "time",
            size: "small",
            disabled: false,
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "收支标识",
        //     fieldName: "ioFlag",
        //     size: "small",
        //     options: ioFlagDs,
        // },
        // {
        //     type: SearchTypeEnum.Input,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "账户编码",
        //     fieldName: "accountCode",
        //     size: "small",
        // },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "状态",
        //     fieldName: "status",
        //     size: "small",
        //     options: [
        //         { label: "初始", value: "0" },
        //         { label: "已记账", value: "1" },
        //         { label: "已核销", value: "2" }
        //     ],
        // },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "取消状态",
        //     fieldName: "cancelStatus",
        //     size: "small",
        //     options: billCancelStatusDs,
        // },

    ]

    return (
        <YhPageHeader
            title="内部账单"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch={false}
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}